import { lazy, Suspense } from 'react';
import { Outlet, Navigate, useRoutes } from 'react-router-dom';

import DashboardLayout from '../layouts/dashboard';
//import Students from '../sections/students/view/user-view';
//export const Students = lazy(() => import('../sections/stude/nts/view/user-view'));
export const Students = lazy(() => import('../pages/students'));
export const IndexPage = lazy(() => import('../pages/app'));
export const AddOrganizationPage  =  lazy(()=> import('../pages/Add-Organization'))
export const EditOrganizationPage  =  lazy(()=> import('../pages/Edit-Organization'))
//export const AddStudentPage  =  lazy(()=> import('../pages/Add-Student'))
/*export const EditStudentPage  =  lazy(()=> import('../pages/Edit-Student'))*/
export const UserPage = lazy(() => import('../pages/user'));
//export const LoginPage = lazy(() => import('../pages/login'));
export const Page404 = lazy(() => import('../pages/page-not-found'));

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      element: (
        <DashboardLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      ),
      children: [
        { element: <IndexPage />, index: true },
        { path: 'organization', element: <UserPage /> },
        { path: 'add-organization', element: <AddOrganizationPage /> },
        { path: 'edit-organization/:organization_id', element: <EditOrganizationPage /> },
        /*{ path: 'add-student', element: <AddStudentPage /> },*/
        { path: 'student', element: <Students/> },
        /*{ path: 'edit-student/:student_id', element: <EditStudentPage/> },*/
        
      ],
    },
    // {
    //   path: 'login',  
    //   element: <LoginPage />,
    // },
    {
      path: '404',
      element: <Page404 />,
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
